module.exports = __webpack_public_path__ + "static/23-5dc7d45cb88777112c92dfc7ab22ff06.jpg";